import { Component, Element, h, Host, Prop } from '@stencil/core'

import Helpers from '../../../utils/helpers'
import { CssClassMap } from '../../../utils/interfaces'

/**
 * ## Design System
 *
 * Para a documentação completa de design, incluindo diretrizes de uso, acessibilidade e exemplos visuais, consulte o [Design System do GovBR](https://www.gov.br/ds/components/footer?tab=designer).
 *
 * @slot default - Slot para informações legais no rodapé, como direitos autorais ou termos de uso.
 */
@Component({
  tag: 'br-footer-legal',
  styleUrl: 'footer-legal.scss',
  shadow: true,
})
export class FooterLegal {
  /**
   * Referência ao elemento host do componente.
   * Utilize esta propriedade para acessar e manipular o elemento do DOM associado ao componente.
   */
  @Element() el: HTMLBrFooterLegalElement

  /**
   * Identificador único.
   * Caso não seja fornecido, um ID gerado automaticamente será usado.
   */
  @Prop({ reflect: true }) readonly customId: string = Helpers.generateUniqueId()

  private getCssClassMap(): CssClassMap {
    return {
      'br-footer-legal': true,
      info: true,
      'text-down-01': true,
      'text-medium': true,
    }
  }

  /**
   * Renderiza o componente.
   * @returns JSX do componente.
   */
  render() {
    return (
      <Host>
        <div id={this.customId} class={this.getCssClassMap()}>
          <slot></slot>
        </div>
      </Host>
    )
  }
}
